import { useCountryInfo } from 'legacy/lut/hooks/useCountryInfo'
import { memo } from 'react'

import { ClickablePhoneWrapper } from 'clickNgo/components/clickablePhoneWrapper'
import { IContact } from 'clickNgo/entities/contact'
import { formatPhoneNumber } from 'clickNgo/helpers/formatPhoneNumber'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { SimpleTable } from 'cng-common/components/simpleTable'

import styles from './ContactDetailsContact.module.scss'

interface Props {
  contact: IContact
}

export const ContactDetailsContact = memo<Props>(({ contact }) => {
  const guid = contact.hpdContactGUID
  const partnerId = contact.partnerId
  const countryOfBusiness = useCountryInfo(contact.countryOfBusiness)
  const mainPhone = formatPhoneNumber({
    number: contact.mainPhoneNumber,
    countryCode: countryOfBusiness?.value,
  })
  const mobilePhone = formatPhoneNumber({
    number: contact.mobilePhoneNumber,
    countryCode: countryOfBusiness?.value,
  })
  const workPhone = formatPhoneNumber({
    number: contact.workPhoneNumber,
    countryCode: countryOfBusiness?.value,
  })
  return (
    <div className={styles.contactDetailsWrapper}>
      <SimpleTable className={styles.contactDetailsTable}>
        <SimpleTable.HeaderRow className={styles.contactDetailsTableHeaderRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Contact
          </SimpleTable.HeaderCell>
        </SimpleTable.HeaderRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Never call
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.isNeverCall ? 'Y' : 'N'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Main phone
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            <RenderWhen condition={Boolean(mainPhone)}>
              <ClickablePhoneWrapper guid={guid} partnerId={partnerId} phoneNumber={mainPhone!} />
            </RenderWhen>
            <RenderWhen condition={!mainPhone}>-</RenderWhen>
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Mobile phone
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            <RenderWhen condition={Boolean(mobilePhone)}>
              <ClickablePhoneWrapper guid={guid} partnerId={partnerId} phoneNumber={mobilePhone!} />
            </RenderWhen>
            <RenderWhen condition={!mobilePhone}>-</RenderWhen>
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Work phone
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            <RenderWhen condition={Boolean(workPhone)}>
              <ClickablePhoneWrapper guid={guid} partnerId={partnerId} phoneNumber={workPhone!} />
            </RenderWhen>
            <RenderWhen condition={!workPhone}>-</RenderWhen>
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Never email
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.isNeverEmail ? 'Y' : 'N'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Email pixels
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.emailPixels ?? '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Email
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.email || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Email Office
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.companyEmail || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Last update
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.lastContactUpdateDate || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
      </SimpleTable>
    </div>
  )
})
